<template>
    <!-- <div class="main-wrap" v-on:scroll.passive="scollPos($event)"> -->
        <div class="main-wrap">
            <img src="../../assets/images/maintenance.png" alt="login" style="padding: 30px;">
        <company-component />
    </div>
</template>

<script>
import HorizontalListComponent from '../component/HorizontalListComponent';
import VerticalListComponent from '../component/VerticalListComponent';
import BannerComponent from '../component/BannerComponent';
import CompanyInfoComponent from '../component/CompanyInfoComponent';

import * as config from '../../js/config';
import common from '../../js/common';
import store from '../../js/store';
import EventBus from '../../js/event_bus';

function getAndroidLocationInfo(data) {
    var getData = JSON.parse(data);
    var callbackFunc = store.getters['getCallbackFunc'].value;
    callbackFunc('get Location success', getData);
}

export default {
    name: 'home_page',
    components: {
        'horizontal-list-component': HorizontalListComponent,
        'vertical-list-component': VerticalListComponent,
        'banner-component': BannerComponent,
        'company-component': CompanyInfoComponent
    },
    data() {
        return {
            // msg: 'Welcome to Your Vue.js App'
            list_type: 'recommend',
            params: {},
            scrollY: '',            
        }
    },
    mounted() {
        var params = common.getParams();
        var reco_data = {
            type: config.REQ_RECOMMEND_STORE_LIST
        }
        this.$refs.vertical.initComponent(reco_data);
        var new_data = {
            type: config.REQ_NEW_STORE_LIST
        }
        this.$refs.horizontal.initComponent(new_data);
        var l_page = this.$store.getters['getLastPage'];
        if (l_page.value == "/detail") {
            setTimeout(function () {
                var el_chk = document.getElementById('elem_' + params.elem_index);
                if (el_chk != null) {
                    document.getElementById('elem_' + params.elem_index).scrollIntoView({
                        behavior: 'smooth'
                    });
                }
            }, 500);
        }
    },
    created() {
        EventBus.$on('set_params', (data) => {
            data.scrollY = this.scrollY; // 스크롤 데이터
            common.setParams(data);
            EventBus.$emit('detail-data', data);
            this.$router.push('/detail');
        });
    },
    destroyed() {
        EventBus.$off('set_params');

    },
    methods: {       
        goNearbyPage() {
            EventBus.$emit('search-init-data', '');
            this.$router.push('/nearby');
        },
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/page/MaintenancePage.vue